var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"photo-video-switch","src":_vm.cameraModeAsset,"alt":"Camera Mode video/photo"},on:{"click":_vm.onClickChangeMode}})])}
var staticRenderFns = []

export { render, staticRenderFns }